"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("./constants");
function getCollectionFromNoteType(collection_class, values) {
  var GENERAL = _constants.NOTE_TYPE_VALUES.GENERAL,
    INTERACTION = _constants.NOTE_TYPE_VALUES.INTERACTION,
    PROVIDED_SERVICE = _constants.NOTE_TYPE_VALUES.PROVIDED_SERVICE;
  var noteValues = values[collection_class];
  switch (collection_class) {
    case GENERAL:
      return {
        interaction: noteValues,
        collection_class: collection_class
      };
    case INTERACTION:
      return {
        interaction: noteValues,
        collection_class: noteValues.type
      };
    case PROVIDED_SERVICE:
      return {
        collection_class: collection_class,
        provided_service: noteValues
      };
    default:
      return {};
  }
}
var _default = exports["default"] = getCollectionFromNoteType;